import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import serviceBanner from '../../assets/another page banner/service.jpg';
import aerospaceCardImg from '../../assets/aerosapce rocket banner.jpg';
import windmillImg      from '../../assets/windmill banner.jpg';
import cementImg        from '../../assets/cement banner.jpg';
import './Services.css';

const services = [
  {
    id: 'aerospace',
    num: '01',
    title: 'Aerospace & Defence',
    subtitle: 'Engineering for Space & Missiles',
    img: aerospaceCardImg,
    description: 'High-tolerance CNC machining of mission-critical structural components for ISRO launch vehicles, BrahMos missile systems, and India\'s crewed Gaganyaan programme.',
    highlights: ['ISRO PSLV & GSLV rings', 'BrahMos missile sub-assemblies', 'Gaganyaan crew module adaptor', '0.02mm dimensional accuracy'],
    link: '/services/aerospace',
    accent: '#00C8E0',
  },
  {
    id: 'windmill',
    num: '02',
    title: 'Windmill Components',
    subtitle: 'Renewable Energy Fabrication',
    img: windmillImg,
    description: 'High-quality fabrication of windmill structural components including tanks, cooling unit pipe lines, trolleys, and pallet systems.',
    highlights: ['Cooling unit pipe lines', 'Structural tanks & frames', 'Trolley & pallet systems', 'Heavy alloy fabrication'],
    link: '/services/windmill',
    accent: '#10B981',
  },
  {
    id: 'cement',
    num: '03',
    title: 'Cement Machinery',
    subtitle: 'Heavy Industrial Machining',
    img: cementImg,
    description: 'Robust machining for cement plant equipment — impellers, valve bodies, pressure vessels, and heavy forging alloy components.',
    highlights: ['Impeller & valve machining', 'Heavy forging alloys', 'Thermal plant vessels', 'Earth-moving parts'],
    link: '/services/cement',
    accent: '#F59E0B',
  },
];

export default function Services() {
  useEffect(() => {
    window.scrollTo(0, 0);
    const els = document.querySelectorAll('.svc-reveal');
    const obs = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.05 }
    );
    els.forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div className="services-page">

      {/* ── HERO WITH BANNER IMAGE ── */}
      <section className="svc-hero">
        <div className="svc-hero__bg-img-wrap">
          <img src={serviceBanner} alt="Services" className="svc-hero__bg-img" />
          <div className="svc-hero__bg-overlay" />
        </div>

        <div className="svc-hero__stars">
          {[...Array(60)].map((_, i) => (
            <div key={i} className="svc-hero__star" style={{ '--i': i }}/>
          ))}
        </div>
        <div className="svc-hero__orb svc-hero__orb--1"/>
        <div className="svc-hero__orb svc-hero__orb--2"/>

        <div className="container svc-hero__content">
          <div className="svc-hero__tag">
            <span className="svc-hero__tag-dot"/>
            Mission-Critical Manufacturing · Est. 2002
          </div>
          <h1 className="svc-hero__title">
            Engineering<br/>
            <span className="svc-hero__title-accent">Precision Components</span>
          </h1>
          <p className="svc-hero__sub">
            From aerospace engineering to heavy industrial fabrication —<br/>
            three verticals, zero compromise.
          </p>
          <div className="svc-hero__clients">
            {['ISRO', 'BrahMos', 'L&T', 'IGCAR', 'FLSmidth'].map(c => (
              <span key={c} className="svc-hero__client-pill">{c}</span>
            ))}
          </div>
        </div>

        <div className="svc-hero__cut"/>
      </section>

      {/* ── SERVICE CARDS ── */}
      <section className="svc-cards-section">
        <div className="container">
          <p className="eyebrow" style={{ justifyContent: 'center', color: 'rgba(255,255,255,0.6)', marginBottom: '0.5rem' }}>What We Do</p>
          <h2 className="section-title svc-cards-heading">Our Services</h2>
          <div className="svc-cards-grid">
            {services.map((svc) => (
              <div
                key={svc.id}
                className="svc-card svc-reveal svc-card--active"
                style={{ '--svc-accent': svc.accent }}
              >
                <div className="svc-card__num">{svc.num}</div>
                {svc.img ? (
                  <div className="svc-card__img-wrap">
                    <img src={svc.img} alt={svc.title} className="svc-card__img" />
                    <div className="svc-card__img-overlay" />
                  </div>
                ) : null}
                <h2 className="svc-card__title">{svc.title}</h2>
                <p className="svc-card__subtitle">{svc.subtitle}</p>
                <p className="svc-card__desc">{svc.description}</p>
                <ul className="svc-card__list">
                  {svc.highlights.map(h => (
                    <li key={h}>
                      <span className="svc-card__dot"/>
                      {h}
                    </li>
                  ))}
                </ul>
                <Link to={svc.link} className="svc-card__btn svc-card__btn--active">
                  Explore →
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="svc-cta">
        <div className="container svc-cta__inner svc-reveal">
          <div>
            <h2 className="svc-cta__title">Need a Custom Engineering Solution?</h2>
            <p className="svc-cta__sub">Our team reviews your drawings and responds within 24 hours.</p>
          </div>
          <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
        </div>
      </section>
    </div>
  );
}